import CreateRole from './CreateRole';
import ManageRole from './ManageRole';
import ManageRoles from './ManageRoles';
import ManageUser from './ManageUser';
import ManageUsers from './ManageUsers';
import ManageUserThresholds from './ManageUserThresholds';

export default {
  CreateRole,
  ManageRole,
  ManageRoles,
  ManageUser,
  ManageUsers,
  ManageUserThresholds,
};
